// John Eldhose 20180511
import React, { Component } from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import { Language } from '@material-ui/icons';
import { connect } from 'react-redux';
import LanguageSelected from '../actions/LanguageSelected';

class App extends Component {

  handleLanguageSelect = event => {
    this.props.onChangeLanguageSelected(event.target.value);
  };

  render () {
    return (
      <TextField
        select
        fullWidth
        className='LanguageSelect'
        SelectProps={{
          native: true
        }}
        onChange={this.handleLanguageSelect}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
            <Language className='IconProp' />
            </InputAdornment>
          )
        }}
      >
        {this.props.Languages.map(option => (
          <option key={option.value} value={option.value}>
          {option.label}
          </option>
        ))}
      </TextField>
    );
  }
};

const mapStateToProps = (state) => {
  return { Languages: state.Languages };
}

const mapDispatchToProps = (dispatch) => ({
  onChangeLanguageSelected: language => dispatch(LanguageSelected(language))
});

const LanguageSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/LanguageSelector.js